// 数值类型 有3种 操作.
// formula_mode - count - 计数
// formula_mode - 'avg': '平均值',
// formula_mode - 'sum': '求和',
const getDataField = (obj, withoutFormulaMode = false) => (obj.formula_mode && !withoutFormulaMode ? `${obj.formula_mode}_${obj.col_name}` : obj.col_name)
const getDataAlias = obj => obj.alias || obj.alias_name || obj.col_name
/*
  提取维度数据
 */
export function pluckDimsData(data, indicators, hook) {
  // 维度
  const dims = {}
  // 报告跳转
  const dimsReportRedirect = {}

  indicators.dims.forEach((dim, i) => {
    let value = []
    let jumpConfig = {}
    const field = getDataField(dim)
    let key = getDataAlias(dim)
    data.forEach((_data) => {
      value.push(_data[field])
    })
    if (dim.dashboard_jump_config) {
      if (typeof dim.dashboard_jump_config === 'string') {
        jumpConfig = JSON.parse(dim.dashboard_jump_config)
      } else {
        jumpConfig = dim.dashboard_jump_config
      }
    }

    let hookData = {
      key,
      value,
      jumpConfig
    }
    if (hook) {
      hookData = hook(hookData, dim, i)
    }

    key = hookData.key
    value = hookData.value
    jumpConfig = hookData.jumpConfig

    dims[key] = value
    if (jumpConfig.isOpen) {
      dimsReportRedirect[key] = jumpConfig || {}
      dimsReportRedirect[key].jump_params = dim.chart_params_jump || []
    }
  })

  return { dims, dimsReportRedirect }
}

/**
 * 转换对比维度数据
 * @param {*} data
 * @param {*} indicators
 */
export function pluckComparisonData(data, indicators) {
  // 对比
  const comparisons = {}
  indicators.comparisons.forEach((compare) => {
    const value = []
    const field = getDataField(compare)
    const key = getDataAlias(compare)
    data.forEach((_data) => {
      value.push(_data[field])
    })
    comparisons[key] = value
  })

  return { comparisons }
}


/*
  提取数值维度数据
  添加 withoutFormulaMode，小计表格数值字段不需要计算方法
 */
export function pluckNumsData(data, indicators, hook, withoutFormulaMode = false) {
  const nums = {}
  const numsDisplayFormat = {}
  const numsReportRedirect = {}
  let primaryNum = null
  indicators.nums.forEach((num, i) => {
    let value = []
    let jumpConfig = {}
    const field = getDataField(num, withoutFormulaMode)
    let key = getDataAlias(num)
    data.forEach((_data) => {
      value.push(_data[field])
    })
    let displayFormat = num.display_format
    if (num.dashboard_jump_config) {
      if (typeof num.dashboard_jump_config === 'string') {
        jumpConfig = JSON.parse(num.dashboard_jump_config)
      } else {
        jumpConfig = num.dashboard_jump_config
      }
    }
    let hookData = {
      key,
      value,
      displayFormat,
      jumpConfig
    }

    if (hook) {
      hookData = hook(hookData, num, i)
    }

    key = hookData.key
    value = hookData.value
    displayFormat = hookData.displayFormat
    jumpConfig = hookData.jumpConfig

    nums[key] = value
    numsDisplayFormat[key] = displayFormat

    const { subtotal_formula_mode, col_name } = num
    const numKey = subtotal_formula_mode ? `${subtotal_formula_mode.toLowerCase()}_${col_name}` : col_name
    numsDisplayFormat[numKey] = displayFormat
    numsDisplayFormat[col_name] = displayFormat // 字段小计改造，导致 subtotal_formula_mode 有默认值

    if (jumpConfig.isOpen) {
      numsReportRedirect[key] = jumpConfig || {}
      numsReportRedirect[key].jump_params = num.chart_params_jump || []
    }

    if (i === 0) {
      primaryNum = key
    }
  })

  return { nums, numsDisplayFormat, numsReportRedirect, primaryNum }
}
/*
  提取次轴数据
*/
export function pluckZaxisData(data, indicators, hook) {
  const zaxis = {}
  const zaxisDisplayFormat = {}
  let primaryAxis = null
  indicators.zaxis && indicators.zaxis.forEach((axis, i) => {
    let value = []
    const field = getDataField(axis)
    let key = getDataAlias(axis)
    data.forEach((_data) => {
      value.push(_data[field])
    })
    let displayFormat = axis.display_format

    let hookData = {
      key,
      value,
      displayFormat
    }

    if (hook) {
      hookData = hook(hookData, axis, i)
    }

    key = hookData.key
    value = hookData.value
    displayFormat = hookData.displayFormat

    zaxis[key] = value
    zaxisDisplayFormat[key] = displayFormat

    const { subtotal_formula_mode, col_name } = axis
    const numKey = subtotal_formula_mode ? `${subtotal_formula_mode.toLowerCase()}_${col_name}` : col_name
    zaxisDisplayFormat[numKey] = displayFormat

    if (i === 0) {
      primaryAxis = key
    }
  })

  return { zaxis, zaxisDisplayFormat, primaryAxis }
}

/*
  提取 column 模式数据 
*/
export function pluckColumnData(data, indicators) {
  const dimsData = {
    dims: {},
    dimsReportRedirect: {}
  }
  const numsData = {
    nums: {},
    numsReportRedirect: {},
    numsDisplayFormat: {},
    primaryNum: ''
  }
  const zaxisData = {
    zaxis: {},
    zaxisDisplayFormat: {},
    primaryAxis: ''
  }
  const comparisonsData = {
    comparisons: {},
    primaryComparison: ''
  }
  const desiresData = {
    desires: {},
    primaryDesire: ''
  }

  const { dims, nums, zaxis, desires, comparisons } = indicators
  const hasComparison = Array.isArray(comparisons) && comparisons.length >= 1
  const hasZaxis = Array.isArray(zaxis) && zaxis.length >= 1
  const hasNums = Array.isArray(nums) && nums.length >= 1
  const hasDims = Array.isArray(dims) && dims.length >= 1
  const hasDesires = Array.isArray(desires) && desires.length >= 1
  
  const { numsDisplayFormat, primaryNum } = pluckNumsData([], indicators)
  const { zaxisDisplayFormat, primaryAxis } = pluckZaxisData([], indicators)
  numsData.numsDisplayFormat = numsDisplayFormat
  numsData.primaryNum = primaryNum
  zaxisData.zaxisDisplayFormat = zaxisDisplayFormat
  zaxisData.primaryAxis = primaryAxis

  if (hasDesires) {
    desiresData.primaryDesire = getDataAlias(desires[0])
  }

  const dimData = data.filter(d => Array.isArray(d.header) && d.header.length > 0 && d.header.every(row => row.col_type === 'dim'))
  dimData.forEach((d) => {
    const key = getDataAlias(d.header[0])
    dimsData.dims[key] = d.rows
  })

  // 有无对比维度，图形展示不同
  if (hasComparison && hasDims && hasNums && dimData.length > 0) {
    const key = getDataAlias(dimData[0].header[0])
    comparisonsData.primaryComparison = getDataAlias(comparisons[0])
    dimsData.dims[key].forEach((name, i) => {
      name = name === null ? '-' : name
      data.forEach((col) => {
        if (col.header[1]) {
          const alias = getDataAlias(col.header[1])
          const cName = getDataAlias(col.header[0])
          // 对比维度
          if (comparisonsData.primaryComparison === cName) {
            if (!comparisonsData.comparisons[cName]) {
              comparisonsData.comparisons[cName] = {
                __comparisonOrder: []
              }
            }
            const col_value = col.header[0].col_value === null ? '-' : col.header[0].col_value
            if (!comparisonsData.comparisons[cName][col_value]) {
              comparisonsData.comparisons[cName][col_value] = []
            }
            comparisonsData.comparisons[cName][col_value] = col.rows

            if (!comparisonsData.comparisons[cName].__comparisonOrder.includes(col_value)) {
              comparisonsData.comparisons[cName].__comparisonOrder.push(col_value)
            }
          }
          // 数值
          if (numsData.primaryNum === alias) {
            if (!numsData.nums[name]) {
              numsData.nums[name] = []
            }
            numsData.nums[name].push(col.rows[i])
            numsData.numsDisplayFormat[name] = numsData.numsDisplayFormat[alias]
          }
          // Z轴
          if (hasZaxis && zaxisData.primaryAxis === alias) {
            if (!zaxisData.zaxis[name]) {
              zaxisData.zaxis[name] = []
            }
            zaxisData.zaxis[name].push(col.rows[i])
          }
          // 目标值
          if (desiresData.primaryDesire === alias) {
            if (!desiresData.desires[alias]) {
              desiresData.desires[alias] = {
                __totalValue: []
              }
            }
            if (!desiresData.desires[alias][name]) {
              desiresData.desires[alias][name] = []
            }
            desiresData.desires[alias][name].push(col.rows[i])
            const idx = desiresData.desires[alias][name].length - 1
            if (desiresData.desires[alias].__totalValue[idx] === undefined) {
              desiresData.desires[alias].__totalValue[idx] = 0
            }
            desiresData.desires[alias].__totalValue[idx] += Number.isNaN(Number(col.rows[i])) ? 0 : col.rows[i]
          }
        }
      })
    })
  }

  // 无对比维度的情况
  if (hasDims && hasNums && dimData.length > 0) {
    data.forEach((col) => {
      const name = getDataAlias(col.header[0])

      if (col.header[0].col_type === 'num') {
        if (nums.find(n => getDataAlias(n) === name)) {
          numsData.nums[name] = col.rows
        }

        if (hasZaxis && zaxis.find(n => getDataAlias(n) === name)) {
          zaxisData.zaxis[name] = col.rows
        }
      }

      if (col.header[0].col_type === 'desire' && desires.find(n => getDataAlias(n) === name)) {
        desiresData.desires[name] = col.rows
      }
    })
  }

  return {
    dimsData,
    numsData,
    zaxisData,
    comparisonsData,
    desiresData
  }
}
